import React from 'react';

export function useResizeObserver(
  ref: React.RefObject<Element>,
  callback: (entry: ResizeObserverEntry) => void,
): void {
  const callbackRef = React.useRef(callback);
  React.useLayoutEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  React.useLayoutEffect(() => {
    const el = ref.current;
    if (!el) {
      return undefined;
    }
    const observer = new ResizeObserver(entries => callbackRef.current(entries[0]));
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);
}
